<template>
    <div>
        <!--------------------------------------radio button----------------------------------------->
        <div class="form-group">
            <div>
                <span class="font-red-sunglo bold">Ajouter la taxe de séjour ?</span>
                <input type="radio" id="sejourtaxnon"  value="sejourtaxnon" v-model="sejourtaxpicked" >
                <label for="sejourtaxnon">Non</label>
                <input type="radio" id="sejourtaxoui" value="sejourtaxoui" v-model="sejourtaxpicked">
                <label for="sejourtaxoui">Oui</label>
            </div>
        </div>
        <!---------------------------------------End radio button----------------------------------------->

        <!---------------------------------------Select Débours ----------------------------------------->

        <div class="row" v-show="sejourtaxpicked == 'sejourtaxoui'">
            <div class="col-md-4">
                <label> Taxes de séjour (en €)</label>
                <input type="number" ref="input" name="sejour_tax" step="0.01" min="0"
                       class="form-control"  v-model="billing.sejour_tax" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "addSejourTaxComponent",
        props: {
            billing: {
                type: Object,
                default: () => {
                    return []
                }
            },
        },
        data () {
            return {
                'sejourtaxpicked' : 'sejourtaxnon',
            }
        },
        mounted () {
            if(this.billing.sejour_tax ){
                this.sejourtaxpicked = 'sejourtaxoui'
            }
        },
        watch: {
            'sejourtaxpicked' : function (newVal, oldVal)//button picked
            {
                if(this.sejourtaxpicked ==  'sejourtaxnon' && oldVal!="")
                {
                    this.billing.sejour_tax = null
                }
            }
        }
    }
</script>

<style scoped>

</style>
